module.exports = __webpack_public_path__ + "static/img/3业务布局-物联网.c2f79217.png";